import 'css-chunksrc/client/pages/projectPage/wbsPage/displayToggle/styles.scss';export default {
  "displayToggle": "_displayToggle_1b7ta_1",
  "title": "_title_1b7ta_10"
};